// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"ec9892c5","977":"389b1639"}[chunkId] + ".chunk.js";
};